import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'patient-portal-conditions',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'ccd',
    'conditions',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/conditions-req.js